import { Box, Button, Grid, Typography } from '@mui/material';
import getAPIUrl from '../../../config';
import postApi from '../../../utils/apiCalls';
import EAdminRoles from '../../../utils/Enums';
import getLocalStorageData from '../../../utils/token';
import FormsPopup from '../../common/FormsPopup/FormsPopup';
import InputField from '../../common/InputField/InputField';
import CustomSelect from '../../common/Select';
import UserAvatar from '../../common/UserAvatar/UserAvatar';
import styles from './styles';
import { EditAdminProfileProps } from './types';
import FormButton from '../../common/FormButton';

const EditAdminProfile = ({
    editAdminDetails,
    setEditAdminDetails,
    selectedRoleId,
    adminInfo,
    handleSubmit,
    handleInput,
    roles,
    handleChangeAvatar,
    selectedImage,
    formErrors,
    submitting,
}: EditAdminProfileProps) => {
    const loginInfo = getLocalStorageData();
    return (
        <FormsPopup
            id="edit_admin_details"
            open={editAdminDetails}
            title="User Profile"
            textAlign="left"
            handleClose={() => setEditAdminDetails(false)}
            width={600}
        >
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <UserAvatar
                            id="edit_admin_profile_pic"
                            name={`${adminInfo.firstname} ${adminInfo.lastname}`}
                            source={selectedImage || adminInfo?.signedUrl || ''}
                            size={279}
                            radius="16px"
                            fontSize={50}
                            isEditing
                            handleChangeAvatar={handleChangeAvatar}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <InputField
                            required
                            id="firstname"
                            label="First Name"
                            type="text"
                            name="firstname"
                            placeholder="Type here..."
                            onChange={handleInput}
                            value={adminInfo.firstname}
                            error={formErrors && formErrors.firstname && formErrors.firstname[0] !== ''}
                            errorMessage={formErrors && formErrors.firstname && formErrors.firstname[0]}
                        />
                        <Typography sx={styles.profileField} component="div">
                            <InputField
                                required
                                id="lastname"
                                label="Last Name"
                                type="text"
                                name="lastname"
                                placeholder="Type here..."
                                onChange={handleInput}
                                value={adminInfo.lastname}
                                error={formErrors && formErrors.lastname && formErrors.lastname[0] !== ''}
                                errorMessage={formErrors && formErrors.lastname && formErrors.lastname[0]}
                            />
                        </Typography>
                        <Typography sx={styles.profileField}>
                            <CustomSelect
                                name="roleId"
                                label="Role"
                                id="roleId"
                                handleOnchange={handleInput}
                                items={roles}
                                value={selectedRoleId}
                                error={formErrors && formErrors.roleId && formErrors.roleId[0] !== ''}
                                errorMessage={formErrors && formErrors.roleId && formErrors.roleId[0]}
                                disabled={
                                    !(loginInfo?.roleName === EAdminRoles.LEADERSHIP) || loginInfo?.id === adminInfo.id
                                }
                            />
                        </Typography>
                        <Typography sx={styles.profileField}>
                            <InputField
                                required
                                id="email"
                                label="Email"
                                type="text"
                                name="email"
                                placeholder="Type here..."
                                onChange={handleInput}
                                value={adminInfo?.email}
                                disabled
                                error={formErrors && formErrors.email && formErrors.email[0] !== ''}
                                errorMessage={formErrors && formErrors.email && formErrors.email[0]}
                            />
                        </Typography>
                    </Grid>
                </Grid>
                <Typography component="div" sx={styles.buttonsContainer}>
                    <Button
                        id="passwordLink"
                        variant="text"
                        sx={styles.sendResetLink}
                        onClick={async () => {
                            await postApi(`${getAPIUrl()}/admins/reset-password`, { email: adminInfo?.email });
                        }}
                    >
                        Send Reset Password Link
                    </Button>
                    <FormButton
                        id="saveChanges"
                        variant="contained"
                        sx={styles.saveUser}
                        type="submit"
                        submitting={submitting}
                    >
                        Save Changes
                    </FormButton>
                </Typography>
            </Box>
        </FormsPopup>
    );
};
export default EditAdminProfile;
